<template>
  <el-container class="content" style="display: block;">

	<el-container class="lables">
		<el-row  class="la-list">
			<el-col :span="24" class="first">
				<el-row>
					<div class="search">
						<input type="text" v-model="searchF" @change="loadData()"/>
					</div>
				</el-row>
				<el-row class="lable-o-l lable-o-ls" v-for="(item,index) in lableFirst" :key="index">
					<div class="title-n" v-for="(items,indexs) in item" :key="indexs" v-if="items['zhu'] == 1">{{items['name']}}</div>
          <el-row>
          	<el-col :span="12">
              <div style="text-align: center;margin-bottom: 20px;font-size: 22px;font-weight: bold;">指令</div>
              <div style="text-align: center;margin-bottom: 5px;background-color: #799CA9;color: #fff;width: 80%;margin-left: 10%;" v-for="(items,indexs) in item" :key="indexs" v-if="items['z_h'] == 1" @click="chose(items.name,items.id,items.pai)">{{items['name']}}</div>
            </el-col>
            <el-col :span="12">
              <div style="text-align: center;margin-bottom: 20px;font-size: 22px;font-weight: bold;">回应</div>
              <div style="text-align: center;margin-bottom: 5px;background-color: #799CA9;color: #fff;width: 80%;margin-left: 10%;" v-for="(items,indexs) in item" :key="indexs" v-if="items['z_h'] == 2" @click="chose(items.name,items.id,items.pai)">{{items['name']}}</div>
            </el-col>
          </el-row>
				</el-row>
			</el-col>

		</el-row>

	</el-container>
	<el-dialog
	  title="修改"
	  :visible.sync="centerDialogVisible"
	  width="30%"
	  center>
	  <input type="text" style="height: 25px;width: 50%;"   class="searchTsx"  v-model="addT"/>
    <input type="text" style="height: 25px;width: 26%;"    class="searchTsx" v-model="order"/>

	  <span slot="footer" class="dialog-footer">
		<el-button @click="centerDialogVisible = false">取 消</el-button>
		<el-button type="primary" @click="doAdd()">确 定</el-button>
	  </span>
	</el-dialog>

  </el-container>
</template>

<script>

  export default {
    data() {
      return {
        lableFirst:[],
        id:0,
        searchF:'',
        order:'0',
        addT:'',
        centerDialogVisible:false,
        token:window.localStorage.getItem('token'),
        userId:window.localStorage.getItem('id'),
        url:this.$store.getters.getUrl
      };
    },
	directives: {
		focus: {
		  inserted: function(el, { value }) {
			if (value) {
			  el.focus();
			}
		  }
		}
    },
    created() {
		//var cip = returnCitySN["cip"];
      if(!window.localStorage.getItem('id')){
        this.$router.push({ path: '/' })
      }
       this.loadData();
	   var lett = this;
	   document.onkeydown = function(e) {
	   	var key = window.event.keyCode;
	   	if (key == 13) {
	   		lett.doAdd();
	   	}

	   }

    },

	methods:{
		loadData(){
			const axiosInstance = this.$axios.create({
				headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
				withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
			});
			axiosInstance({
				method:'get',
				params:{
					name:this.searchF
				},
				url:'http://fencip.yoooooo.com/index.php/index/data/acFirst'
			})
			.then(res=>{
				this.lableFirst = res.data;

			})
			.catch(err=>{

			});
		},
    chose(name,id,order){
      this.id = id
      this.order = order
      this.addT = name
      this.centerDialogVisible = true
    },
		msg(msg,type){
			this.$message({
			  message: msg,
			  type: type
			});
		},
		doAdd(){
			let p_id = this.choses;
			const axiosInstance = this.$axios.create({
				headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
				withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
			});
			axiosInstance({
				method:'post',
				params:{
          id :this.id,
					name:this.addT,
					order:this.order,
					token:this.token,
					userId:this.userId
				},
				url:'http://fencip.yoooooo.com/index.php/index/data/acFirstChange'
			})
			.then(res=>{
				if(res.data.code == 200){
					this.centerDialogVisible = false;
					this.addT = '';
					this.order = 0
					this.loadData();
				}else{
					this.centerDialogVisible = false;
					this.addT = '';
					alert('修改失败')
				}

			})
			.catch(err=>{

			});
		},

	}


  }
</script>

<style>
  .title-n{
    text-align: center;
    font-size: 28px;
    margin-right: 50px;
  }
	.content{
		background: #939AA0;
		width: 100%;
		height: 100%;
	}
	.centr{
		margin-top: 30%;
	}
	.centr img{
		width: 100px;
		height: 50px;
		margin-left: 35px;
	}

	.zhuyi{
		color: red;
	}
	.butn{
		color: #F0F8FF;
		background: #FF9400;
		margin-right: 20px;
		border-radius: 5px;
		width: 50px;
	}
	.lables{
		margin-left: 5%;
		margin-right: 5%;
		background: #fff;
		padding-bottom: 35px;
	}
	.lables .la-list{
		margin-top: 50px;
		width: 100%;
		margin-left: 20%;
		margin-right: 20%;
	}
	.first{
		border: 1px solid #c6c6c6;
		height: 850px;
		overflow-y:scroll;
	}
	.first .el-row{
		margin: 20px 10% 20px 10%;
	}
	.search input{
		width: 95%;
		height: 20px;
		margin-bottom: 10px;
		margin-left: 2%;
	}
	.add{
		text-align: center;
		width: 96%;
		background: #c6c6c6;
		height: 22px;
		line-height: 22px;
		margin-left: 2%;
	}

	.lable-o{
		width: 47%;
		text-align: center;
		background: #c6c6c6;
		height: 30px;
		line-height: 30px;
		margin-bottom: 10px;
	}
	.lable-two{

		text-align: center;
		background: #c6c6c6;

		line-height: 30px;
		margin-bottom: 10px;
	}
	.choses{
		background: #f8f1da;
	}
	.chosess{
		background: #ff9400;
	}
	.right{
		float: right;
	}
	.left{
		float: left;
	}
	.two{
		border: 1px solid #c6c6c6;
		height: 850px;
		overflow-y:scroll;
	}
	.two .el-row{
		margin: 20px 10% 20px 10%;
	}
	.searchT{
		width: 80%;
		margin-left: 10%;
		height: 30px;
	}
	.lable-o-ls{
		border-bottom: 1px solid #c6c6c6;
	}
</style>



// WEBPACK FOOTER //
// src/components/main/orderby.vue